var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "main-testimonials__list" },
        [
          _c(
            "transition-group",
            { attrs: { name: "fade" } },
            _vm._l(_vm.testimonials, function(item) {
              return _c(
                "article",
                { key: item.title, staticClass: "main-testimonials__item" },
                [
                  _c("header", [
                    _c("div", { staticClass: "img" }, [
                      _c("img", { attrs: { src: item.photo, alt: "" } })
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "name" }, [
                      _vm._v(_vm._s(item.title))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "social" },
                      _vm._l(item.socials, function(sn) {
                        return _c(
                          "a",
                          { attrs: { href: sn.url, target: sn.target } },
                          [
                            _c("svg", { staticClass: "icon", class: sn.icon }, [
                              _c("use", {
                                attrs: {
                                  "xlink:href":
                                    "/images/svg-symbols.svg#" + sn.icon
                                }
                              })
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { domProps: { innerHTML: _vm._s(item.text) } })
                  ])
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", duration: 350 } },
        [
          _vm._t("default", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.testimonials.length < _vm.total,
                    expression: "testimonials.length < total"
                  }
                ],
                staticClass: "more-delimiter"
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "button-pill",
                    class: { loading: _vm.isLoading },
                    on: {
                      click: function($event) {
                        return _vm.getTestimonials()
                      }
                    }
                  },
                  [_vm._v("Смотреть еще")]
                )
              ]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }